import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { handleEvent } from "util/user-events";

interface DesignState {
    useNewDesign: "default" | "legacy" | "new";
    theme: "light" | "dark" | "system";
    sidebarState: "expanded" | "collapsed";
}
const initialState: DesignState = {
    useNewDesign: "default",
    theme: "light",
    sidebarState: "expanded",
};

export const designSlice = createSlice({
    name: "design",
    initialState,
    reducers: {
        setPreviewDesign: (
            state,
            action: PayloadAction<"default" | "legacy" | "new">,
        ) => {
            state.useNewDesign = action.payload;
            setTimeout(() => {
                handleEvent("user-preview-design-toggle", {
                    design: action.payload,
                });
            }, 0);
        },
        setTheme: (state, action: PayloadAction<"light" | "dark" | "system">) => {
            state.theme = action.payload;
        },
        setSidebarState: (state, action: PayloadAction<"expanded" | "collapsed">) => {
            state.sidebarState = action.payload;
        },
    },
});
